<template>
  <a-radio-group v-if="tagType == 'radio'" @change="handleInput" :value="getValueString" :disabled="disabled">
    <a-radio v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ getTextString(item) }}</a-radio>
  </a-radio-group>

  <a-checkbox-group v-else-if="tagType == 'check'" @change="handleInput" :value="getValueString" :disabled="disabled">
    <a-checkbox v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ getTextString(item) }}</a-checkbox>
  </a-checkbox-group>

  <span v-else-if="type == 'label'">
    <template v-if="fix">
      <fix v-if="XEUtils.isArray(getValueString)">
        <span>{{
          XEUtils.map(
            XEUtils.filter(dictOptions, (r) => getValueString.includes(r.value)),
            (m) => m.text
          ).join('，')
        }}</span>
      </fix>

      <fix v-else-if="!XEUtils.isArray(getValueString)">
        <span v-for="(item, index) in dictOptions" :key="index" v-show="getValueString == item.value">{{
          getTextString(item)
        }}</span>
      </fix>
    </template>

    <template v-else>
      <span v-if="XEUtils.isArray(getValueString)">
        <span>{{
          XEUtils.map(
            XEUtils.filter(dictOptions, (r) => getValueString.includes(r.value)),
            (m) => m.text
          ).join('，')
        }}</span>
      </span>

      <span v-else-if="!XEUtils.isArray(getValueString)">
        <span v-for="(item, index) in dictOptions" :key="index" v-show="getValueString == item.value">{{
          getTextString(item)
        }}</span>
      </span>
    </template>
  </span>

  <!-- hong@2020-08-23: -->
  <!-- :getPopupContainer="target => target.parentNode"导致在td内的时候显示不全,故删除 -->
  <!-- :getPopupContainer="target => target.closest('.app-body')" -->
  <!--@select="handleSelect"-->
  <a-select
    v-else-if="tagType == 'select'"
    :mode="mode"
    :filterOption="filterOption"
    :class="tagTheme"
    :dropdownClassName="tagTheme"
    :allowClear="allowClear"
    :showSearch="showSearch"
    :getPopupContainer="getPopupContainer"
    :tokenSeparators="tokenSeparators"
    :placeholder="placeholder"
    :disabled="disabled"
    :value="getValueString"
    @change="handleInput"
  >
    <a-select-option :value="undefined" v-if="showBlank">
      <span style="color: rgb(191, 191, 191)">{{ placeholder }}</span>
    </a-select-option>
    <a-select-option v-for="(item, key) in dictOptions" :key="key" :value="item.value">
      <span style="display: inline-block; width: 100%" :title="getTextString(item)">{{ getTextString(item) }}</span>
    </a-select-option>
  </a-select>
</template>

<script>
import { ajaxGetDictItems } from '@/api/api'

export default {
  name: 'JDictSelectTag',
  props: {
    excludeValues: {
      type: Array,
      default: () => [],
    },
    dictCode: Object,
    placeholder: {
      type: String,
      default: function () {
        if (this.$t) {
          return this.$t('disp.ph.select.default')
        }
      },
    },
    mode: {
      type: String,
      default: 'default',
    },
    getPopupContainer: String,
    triggerChange: Boolean,
    disabled: Boolean,
    value: [String, Number, Array],
    type: String,
    returnType: {
      type: String,
      default: 'string',
    },
    tagTheme: {
      type: String,
      default: '',
    },
    fix: {
      type: Boolean,
      default: false,
    },
    showBlank: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    require: Boolean,
    cache: {
      type: Boolean,
      default: true,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    showText1: {
      type: Boolean,
      default: false,
    },
    showText2: {
      type: Boolean,
      default: false,
    },
    tokenSeparators: {
      type: Array,
      default: [','],
    },
    filterOption: {
      type: Function,
    },
  },
  data() {
    return {
      dictOptions: [],
    }
  },
  watch: {
    dictCode: {
      immediate: true,
      handler() {
        this.initDictData()
      },
    },
  },
  created() {},
  computed: {
    tagType() {
      if (!this.type || this.type === 'list') {
        return 'select'
      } else {
        return this.type
      }
    },
    getValueString() {
      if (XEUtils.isUndefined(this.value) || XEUtils.isNull(this.value) || this.value === '') {
        return undefined
      } else {
        if (this.tagType == 'check') {
          if (Array.isArray(this.value)) {
            return this.value
          } else {
            //var arr = []
            //arr.push(this.value)
            //return arr
            return this.value.split(',')
          }
        } else {
          if (this.tagType == 'radio') {
            this.$emit('emit', this.getEmitInfo(this.dictOptions, this.value))
          }

          if (this.mode == 'multiple' || this.mode == 'tags') {
            return this.value.split(',')
          }

          return this.value
        }
      }
    },
  },
  methods: {
    async initDictData() {
      if (!this.dictCode) {
        this.dictOptions = []
        this.$emit('change', undefined, undefined)
        this.$emit('input', undefined, undefined)
        this.$emit('emitText', undefined, undefined)
      } else if (Array.isArray(this.dictCode)) {
        this.dictOptions = this.dictCode
      } else {
        if (this.cache && this.dictCode.indexOf(';') < 0 && sessionStorage['dictCode_' + this.dictCode]) {
          this.dictOptions = JSON.parse(sessionStorage['dictCode_' + this.dictCode])
        } else {
          //根据字典Code, 初始化字典数组
          await ajaxGetDictItems(this.dictCode, null).then((res) => {
            if (res.success) {
              if (sessionStorage['dictCode_' + this.dictCode] == undefined) {
                sessionStorage['dictCode_' + this.dictCode] = JSON.stringify(res.result)
              }
              this.dictOptions = res.result
              this.$emit('emitText', this.getTextEmitInfo(this.dictOptions, this.value))
            }
          })
        }
      }

      if (this.excludeValues != null && this.excludeValues.length > 0) {
        this.excludeValues.forEach((excludeValue) => {
          var index = this.dictOptions.findIndex((item) => {
            if (item.value == excludeValue) {
              return true
            }
          })
          this.dictOptions.splice(index, 1)
        })
      }
    },
    getTextString(item) {
      if (this.showText1) {
        return item.text1
      } else if (this.showText2) {
        return item.text2
      } else {
        return item.text
      }
    },
    handleInput(e, option) {
      let val
      if (this.tagType == 'radio') {
        val = e.target.value
        this.$emit('emit', this.getEmitInfo(this.dictOptions, val))
      } else {
        val = e
      }

      // 需要两次emit才能生效,原因未知
      if (XEUtils.isUndefined(val) || XEUtils.isNull(val) || val === '') {
        this.$emit('change', undefined, null)
        this.$emit('input', undefined, null)
        this.$emit('select', undefined, null)
        this.$emit('emitText', undefined)

        this.$emit('change', undefined, null)
        this.$emit('input', undefined, null)
        this.$emit('select', undefined, null)
        this.$emit('emitText', undefined)

        setTimeout(() => {
          this.$emit('change', undefined, null)
          this.$emit('input', undefined, null)
          this.$emit('select', undefined, null)
          this.$emit('emitText', undefined)
        }, 1)
      } else {
        var emitInfo = this.getTextEmitInfo(this.dictOptions, val)

        var text = val && emitInfo.length > 0 ? emitInfo.map((r) => r.text).join(',') : null

        if (Array.isArray(val)) {
          var joinVal = val.join(',')
        } else {
          var joinVal = val
        }

        this.$emit('change', joinVal, text)
        this.$emit('input', joinVal, text)
        this.$emit('select', joinVal, text)
        this.$emit('emitText', emitInfo)

        this.$emit('change', joinVal, text)
        this.$emit('input', joinVal, text)
        this.$emit('select', joinVal, text)
        this.$emit('emitText', emitInfo)

        setTimeout(() => {
          this.$emit('change', joinVal, text)
          this.$emit('input', joinVal, text)
          this.$emit('select', joinVal, text)
          this.$emit('emitText', emitInfo)
        }, 1)
      }
    },
    //handleSelect(e, option) {
    //  var text =
    //    e && this.getTextEmitInfo(this.dictOptions, e).length > 0
    //      ? this.getTextEmitInfo(this.dictOptions, e)[0].text
    //      : null
    //  this.$emit('change', e, text)
    //  this.$emit('input', e, text)
    //  this.$emit('emitText', text)
    //  this.$emit('select', e, text)
    //},
    setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions
    },
    getCurrentDictOptions() {
      return this.dictOptions
    },
    // radio 返回数据
    getEmitInfo(list, val) {
      if (list && list.length) {
        let obj = {}
        obj = list.find((item) => {
          return item.value == val
        })
        return obj
      }
    },
    /**
     * @description 返回所有选中的项目的所有值（value,text,title）
     * @param list 数据字典所获取到的值
     * @param val 被选中项目的值
     */
    getTextEmitInfo(list, val) {
      if (list && list.length) {
        let valList = []
        // 如果是radio或者select 则变为[val]
        if (!Array.isArray(val)) {
          valList.push(val)
        } else {
          valList = val
        }
        let arr = []
        arr = list.filter((item, index) => {
          return valList.indexOf(item.value) != -1
        })
        return arr
      }
    },
  },
}
</script>

<style scoped></style>
